window.LMSAPI = new function () {
    var self = this;
    var _protected = BaseAPI.call(self);
    var LmsUrl = publicConfiguration.LMS_SERVERS;

    _protected.setApiUrl(environmentsConfig.getEnv().host == environmentsConfig.TEAM_SCHEDULE ? publicConfiguration.tsCoreServersBaseURL : publicConfiguration.APIServerBaseURL);

    self.getSettings = function (brandId) {
        var deferred = $q.defer();

        _protected.request(LmsUrl + "brands/" + brandId + "/settings", 'GET')
            .then(function (res) {
                deferred.resolve(res.data.data);
            }).catch(function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getUpskillCoursesLink =  (brandId, params) => {
        var deferred = $q.defer();

        _protected.request(LmsUrl + `upskill/brands/${brandId}/launch`, 'GET', params)
            .then((res) => {
                deferred.resolve(res.data.data);
            }).catch((err) => {
            deferred.reject(err);
        });

        return deferred.promise;
    };


};
